import type { DeviceStatus } from '../types';

const STATUS_STYLES: Record<DeviceStatus, { bg: string; ring: string }> = {
  online: { bg: 'bg-emerald-400', ring: 'ring-emerald-400/30' },
  idle: { bg: 'bg-amber-400', ring: 'ring-amber-400/30' },
  faulted: { bg: 'bg-red-400', ring: 'ring-red-400/30' },
  offline: { bg: 'bg-gray-500', ring: 'ring-gray-500/30' },
};

interface StatusDotProps {
  status: DeviceStatus;
  size?: 'sm' | 'md';
  showLabel?: boolean;
}

export function StatusDot({ status, size = 'sm', showLabel = false }: StatusDotProps) {
  const s = STATUS_STYLES[status] ?? STATUS_STYLES.offline;
  const dotSize = size === 'sm' ? 'w-2 h-2' : 'w-3 h-3';

  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={`${dotSize} rounded-full ${s.bg} ring-2 ${s.ring}`} />
      {showLabel && (
        <span className="text-xs capitalize text-gray-400">{status}</span>
      )}
    </span>
  );
}
